/*###########################################################################
// Script handling
//#########################################################################*/

import { inViewport } from '../utilities/_inViewport'
import { throttle } from '../utilities/_throttleDebounce'

const formieSelector = 'form[data-formie-form]'

const scriptHandling = {
	scriptsLoaded: [],
	mapAssets: null,
	formieStarted: false,

	init() {
		const self = this

		if (!self.formieStarted && document.querySelector(formieSelector) !== null) {
			self.formieStarted = true

			import('@verbb/formie-browser').then(({ formie }) => {
				formie({
					element: formieSelector,
					observe: true,
					allowEmpty: true,
				})
			})

			document.addEventListener('formie:submit:result', (e) => {
				const form = e.target

				if (e.detail && e.detail.ok && form instanceof HTMLFormElement && form.hasAttribute('data-brochure-form')) {
					window.brochureForm.handleFormSubmit(e)
				}
			})
		}

		if (self.mapAssets !== null) {
			const autoCompleteInput = document.querySelector('[data-places-autocomplete]')
			if (autoCompleteInput !== null) {
				window.addEventListener('scroll', throttle(function() {
					if (inViewport(autoCompleteInput, -window.innerHeight) && !self.scriptsLoaded.includes(0)) {
						console.log('in view');

						self.addScript(self.mapAssets[0].src, function() {
							self.scriptsLoaded.push(0)

							setTimeout(function() {
								new google.maps.places.Autocomplete(
									(autoCompleteInput),
									{
										types: ['geocode'],
										componentRestrictions: { country: 'uk' }
									}
								);
							}, 500)
						})
					}
				}, 200))
			} else if (autoCompleteInput !== null) {
				setTimeout(function() {
					new google.maps.places.Autocomplete(
						(autoCompleteInput),
						{
							types: ['geocode'],
							componentRestrictions: { country: 'uk' }
						}
					);
				}, 500)
			}
		}
	},

	addScript(src, onload) {
		const self = this

		const script = document.createElement('script')
		script.charset = 'utf-8'
		script.type = 'text/javascript'
		script.src = src

		// Append the script to the head
		document.head.appendChild(script)

		script.onload = onload
	}
}

window.addEventListener('load', function() {
	const mapAssets = document.querySelector('script[data-map-assets]')
	if (mapAssets !== null) {
		scriptHandling.mapAssets = JSON.parse(mapAssets.getAttribute('data-map-assets'))
	}
})

initComponent(() => {
	scriptHandling.init()
})
